export default {
  main: '#000000',
  secondary: '#c18c5e',
  contrastingColor: '#ffffff',
  priceColor: '#c18c5e',
  entryBackground: '#000000',
  menuBackgroundColor: '#000000',
  menuTextColor: '#ffffff',
};
